module.exports = __webpack_public_path__ + "img/spartan-work-order.a038c800.jpg";